import axios from "axios";
import { url } from "../baseUrl";

export const EnumerationStore = {
  state: {
    searchresult: [],
    allbuildings: [],
    resultnumber: "",

    markers: []
  },
  mutations: {
    setBuilding(state, data) {
      let current_page = data.current_page;
      state.allbuildings = data.data.map((item, index) => ({
        index: (current_page - 1) * data.limit + index + 1,
        id: item.id,
        description: item.description,
        ipaddress: item.ipaddress,
        vendor: item.vendor,
        city: item.city,
        country: item.country,
        location: item.location,
        source: item.soucre,
        latitude: item.latitude,
        longitude: item.longitude,
        upload: item.upload
      }));
      state.resultnumber = data.count;
    },
    setMarkers(state, data) {
      state.markers = data.map((item, index) => ({
        position: {
          lat: Number(item.latitude),
          lng: Number(item.longitude)
        },
        icon: { url: "assets/images/map-marker.png" }
      }));
    }
  },
  actions: {
    geographicalBuilding(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/enumeration/map/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {            
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    searchBuilding(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/enumeration/search/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            context.commit("setBuilding", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    allBuilding(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/enumeration/search/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            context.commit("setBuilding", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    setMarkers(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/enumeration/map/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            context.commit("setMarkers", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  getters: {
    resultnumber: state => {
      return state.resultnumber;
    }
  }
};
